// Libs
import * as React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import DeleteIcon from '@material-ui/icons/Delete'
import IconButton from '@material-ui/core/IconButton'
import Button from '@material-ui/core/Button'
import { RouteComponentProps } from 'react-router-dom'
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
// Components
import LoaderIcon from '../shared/LoaderIcon'
// Store
import { logOut, setAgentBusinessUnit } from '../core/duck/actions'
// Helpers
import { IProfileState} from '../lib/interface'
import Auth from '../lib/Auth'
// Assets
import Loader from '../shared/Loader'

// import {API_URL} from '../core/constants'
import Requests from 'src/lib/requests';
import requests from 'src/lib/requests';

interface IView {id: number, assetClasses: any[],name: string, email: string, mobile: string}

interface IState {
  viewItems: IView[]
  deletingViewId: string
  loadingViews: boolean
}


interface IProps extends RouteComponentProps<{}> {
  classesData: any[]
  profile: IProfileState
  logOut: () => void
  businessLines: any[]
  setAgentBusinessUnit: (unit: {
    name: string,
    id: number
  }) => void
}

class ViewsList extends React.Component<IProps, IState> {
  public state = {
    viewItems: [],
    deletingViewId: "0",
    loadingViews: false
  }
  public async componentDidMount() {
    this.setState({ loadingViews: true })

    // Grab existing views from WP
    const [viewsRes, formsRes] = await Requests.getManagedData()

    const forms = formsRes.data

    const viewItems : IView[] = viewsRes.data.map((view: any) => {
      const { classes } = view.acf

      const assetClasses =
        classes && classes.length
          ? classes.map((classItem: any) => classItem.name)
          : []

      // Grab the associated lead form for client details
      const assocForm = forms.entries.find(
        (form: any) => form[6] === view.id.toString()
      )

      return {
        id: view.id,
        assetClasses,
        name: view.title.rendered,
        email: assocForm && assocForm['7'],
        mobile: assocForm && assocForm['5']
      }
    })

    this.setState({ viewItems, loadingViews: false })
  }

  public logout = () => {
    this.props.logOut()
    Auth.clearSession()

  }

  public deleteView = async (id: string) => {
    // State to handle loading icon
    this.setState({ deletingViewId: id })

    try {
      // Make the call
      await requests.deleteView(id)
      this.setState({
        viewItems: this.state.viewItems.filter(
          (viewItem: any) => viewItem.id !== id
        ),
        deletingViewId: "0"
      })
    } catch (e) {
      console.log(e)
    }
  }

  public handleBUChange = (event: any) => {
    const { name } = this.props.businessLines.find((bl: any) => bl.id === event.target.value)
    localStorage.setItem('agent-businessunit', JSON.stringify({name, id: event.target.value}))
    this.props.setAgentBusinessUnit({name, id: event.target.value})
  }

  public render() {
    return (
      <Outer>
        <WelcomeMessage>
          <h2>Welcome back {this.props.profile.given_name}</h2>
          
          <FormControl style={{minWidth: '140px'}}>
          <InputLabel htmlFor="business-unit">My Business Unit</InputLabel>
          <Select
            value={this.props.profile.businessUnit.id}
            onChange={this.handleBUChange}
            inputProps={{
              name: 'business-unit',
              id: 'business-unit',
            }}
          >
          {this.props.businessLines.map((bl:any) =>  <MenuItem key={bl.id} value={bl.id}>{bl.name}</MenuItem>)}
          </Select>
        </FormControl>
        
          <div>           
            <Button >          
            <Link style={{color: '#E4002B'}} to="views/new">Create new</Link>
            </Button>  
          <Button style={{color: '#0093B2'}} onClick={this.logout}>Sign out</Button>
          </div>
        </WelcomeMessage>
        <Container>
          <Header>
            <div>Experience manager</div>
            <div>Completed experiences</div>
          </Header>
          {this.state.loadingViews ? (
            <Loader />
          ) : (
            <List dense={false}>
              {this.state.viewItems.length > 0 ? this.state.viewItems.map((viewItem: any) => {
                  let viewDetailsText = viewItem.assetClasses
                    .map((assetName: string) => ` ${assetName}`)
                    .toString()
                  viewDetailsText += ` | ${viewItem.email} | ${
                    viewItem.mobile
                  } `
                  return (
                    <React.Fragment key={viewItem.id}>
                      <ListItem
                        className="view-list-item"
                        classes={{ container: 'view-list-item-container' }}
                      >
                        <div>{viewItem.name}</div>
                        <ListItemText
                          primary={viewDetailsText}
                          className="list-item-text"
                        />
                        <ListItemSecondaryAction>
                          <IconButton aria-label="Delete">
                            {this.state.deletingViewId === viewItem.id ? (
                              <LoaderIcon />
                            ) : (
                              <DeleteIcon
                                onClick={() => this.deleteView(viewItem.id)}
                              />
                            )}
                          </IconButton>
                        </ListItemSecondaryAction>
                      </ListItem>
                      <Seperator />
                    </React.Fragment>
                  )
                }) : <EmptyMessage><p>There aren't any existing views, create one <Link to='/views/new'>here</Link> </p> </EmptyMessage> }
            </List>
          )}
        </Container>
      </Outer>
    )
  }
}

const mapStateToProps = (state: any) => ({
  classesData: state.data.classes,
  profile: state.profile,
  businessLines: state.data.businessLines
})

export default connect(
  mapStateToProps,
  { logOut, setAgentBusinessUnit}
)(ViewsList)


const WelcomeMessage = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 80%;
  margin: 0 auto;

  h2 {
    font-weight: 300;
    color: #676666;
    font-size: 20px;
  }
  @media only screen and (max-width: 1100px) {
    width: 95%;
  }

    @media only screen and (max-width: 680px) {
      flex-direction: column;
  }
`

const Outer = styled.div`
  width: 95%;
  margin: 0 auto;
  padding-top: 120px;
  display: flex;
  flex-direction: column;
  position: relative;
`

const Container = styled.div`
  background-color: #fff;
  width: 80%;
  margin: 70px auto;
  margin-top: 10px;

  > hr:first-child {
    width: 95%;
    border-top: 1px solid #f9f9f9;
    margin: 0 auto;
    margin-top: 25px;
  }

  .view-list-item-container {
    width: 95%;
    clear: both;
    float: right;
  }

  .view-list-item {
    clear: both;
    padding: 20px;
    padding-left: 0px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .list-item-text {
      padding: 0px;
      span {
        font-size: 15px;
        font-weight: 300;
      }
    }

    > div:first-child {
      font-size: 19px;
    }
  }

  @media only screen and (max-width: 1100px) {
    width: 95%;
  }
`

const Header = styled.div`
  width: 95%;
  margin: 0 auto;
  border-bottom: 1px solid #eee;
  font-weight: 400;
  > div:first-child {
    text-transform: uppercase;
    letter-spacing: 1px;
    font-size: 14px;
    padding-top: 20px;
    padding: 20px 0px 0px 20px;
    color: grey;
  }

  > div:last-child {
    font-weight: bold;
    font-size: 20px;
    padding: 10px 0px 30px 20px;
  }
`

const Seperator = styled.hr`
  border-bottom: 0.5px solid #eee;
  width: 95%;
  float: right;
`

const EmptyMessage = styled.div`
  width: 95%;
  margin: 0 auto;
`


// WEBPACK FOOTER //
// ./src/views/List.tsx